import { Icon, List, ListItem } from "framework7-react";

export function SettingList() {
  return (
    <List
      dividersIos
      inset
      mediaList
      strong
    >
      <ListItem
        chevronCenter
        link="/settings/account/"
        title="アカウント"
      >
        <Icon
          material="account_circle"
          slot="media"
        />
      </ListItem>

      <ListItem
        chevronCenter
        link="/settings/app/"
        title="アプリ設定"
      >
        <Icon
          material="settings"
          slot="media"
        />
      </ListItem>

      <ListItem
        chevronCenter
        link="#"
        title="使い方"
      >
        <Icon
          material="favorite"
          slot="media"
        />
      </ListItem>

      <ListItem
        chevronCenter
        link="/settings/app-about/"
        title="アプリについて"
      >
        <Icon
          material="info"
          slot="media"
        />
      </ListItem>
    </List>
  );
}
